import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import { ErrorBoundary } from 'react-error-boundary';

import { GridLayoutSizes } from 'types/app';
import { ContentFragment } from 'api';
import { PaddedPaper } from 'components';

import { FeedGridItem } from 'features/content';

interface Props {
  result: ContentFragment;
  variant: GridLayoutSizes;
}

const GridResult: FC<Props> = ({ result, variant }) => {
  const { t } = useTranslation();

  function handleFeedError() {
    return (
      <PaddedPaper>
        <Typography>{t('errors:feed')}</Typography>
      </PaddedPaper>
    );
  }

  if (!result) {
    return null;
  }

  return (
    <ErrorBoundary key={result.content_id} fallback={handleFeedError()}>
      <FeedGridItem content={result} variant={variant} />
    </ErrorBoundary>
  );
};

export default GridResult;
